import React, { useState } from 'react';
import { Slide } from 'pure-react-carousel';
import { useHistory } from 'react-router-dom';
import css from './SectionRewards.css';
import classNames from 'classnames';
import { Button } from '../../../../components';
import { AwardCard as Card } from './AwardCard';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { parse } from '../../../../util/urlHelpers';
import { ConditionalWrapper } from '../../../../util/common';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import Carousel from '../../../../components/ListingCardsCarousel/Carousel';
import {
    allAwardTypes,
    AWARD_TYPE_ALL,
    AWARD_TYPE_HORSE_PROFILE,
    AWARD_TYPE_RIDER_PROFILE,
} from './awardType';
import { useAwardsCards } from './useAwardsCards';
import { useSelector } from 'react-redux';
import config from '../../../../config';
import sortAwardsByActiveAction from './sortAwardsByActiveAction';

const { userTypeHorseowner, userTypeRider } = config;

export default () => {
    const history = useHistory();
    const [isMobile, _, computing, viewport] = useIsMobile(1024);

    const isTablet = viewport > 768 && viewport < 1024;

    const currentUser = useSelector(s => s.user.currentUser);
    const { userType } = currentUser?.attributes?.profile?.publicData || {};

    const isRider = userType === userTypeRider;
    const isHorseowner = userType === userTypeHorseowner;

    const [awardSelected, setAwardSelected] = useState(AWARD_TYPE_ALL);

    const searchParams = parse(history.location.search);

    const filterAwardsByTypeSelected = awards => {
        if (awardSelected === AWARD_TYPE_ALL) {
            return awards;
        }
        return awards.filter(a => a.type === awardSelected);
    };

    const filterAwardTypesByUserType = types => {
        if (isRider) {
            return types.filter(t => t !== AWARD_TYPE_HORSE_PROFILE);
        }
        if (isHorseowner) {
            return types.filter(t => t !== AWARD_TYPE_RIDER_PROFILE);
        }
        return types;
    };

    const navigate = (name, pathParams = {}, searchParams = {}) =>
        history.push(
            createResourceLocatorString(name, routeConfiguration(), pathParams, searchParams)
        );

    const awardCards = useAwardsCards(currentUser, navigate, searchParams);

    const minNumToShowSlider = isTablet ? 2.1 : isMobile ? 1 : 3;
    const showSlider = awardCards?.length > minNumToShowSlider;
    const showCardsSection = awardCards && !computing;

    return (
        <section className={css.root}>
            <header>
                <h2 className={css.heading}>Rewards</h2>
                <p className={css.description}>Erhalte kostenlose Credits als Reward.</p>
            </header>
            <nav className={css.tabsNavigation}>
                {filterAwardTypesByUserType(allAwardTypes).map(tab => (
                    <Button
                        key={tab}
                        onClick={() => setAwardSelected(tab)}
                        className={classNames(css.tab, {
                            [css.tabSelected]: tab === awardSelected,
                        })}
                    >
                        {tab}
                    </Button>
                ))}
            </nav>
            {showCardsSection && (
                <div
                    className={classNames({
                        [css.cardsHolder]: !showSlider,
                    })}
                >
                    <ConditionalWrapper
                        condition={showSlider}
                        wrapper={children => (
                            <Carousel
                                key={`${awardSelected}-${isMobile}-${isTablet}`}
                                isMobile={isMobile}
                                items={children}
                                sliderClassName={css.slider}
                                sliderVisibleSlides={minNumToShowSlider}
                                hideButtonsOnEndStart
                                rendererCarousel={(card, index) => (
                                    <Slide index={index} key={index}>
                                        {card}
                                    </Slide>
                                )}
                                rendererSingleItem={card => card}
                            />
                        )}
                    >
                        {sortAwardsByActiveAction(
                            filterAwardsByTypeSelected(awardCards),
                            isMobile
                        ).map(
                            ({
                                id,
                                credits,
                                heading,
                                description,
                                actionText,
                                actionHandler,
                                actionAllowed,
                            }) => (
                                <Card key={id}>
                                    <Card.Badge>{credits}</Card.Badge>
                                    <Card.Header>{heading}</Card.Header>
                                    <Card.Description>{description}</Card.Description>
                                    <Card.Action disabled={!actionAllowed} onClick={actionHandler}>
                                        {actionText}
                                    </Card.Action>
                                </Card>
                            )
                        )}
                    </ConditionalWrapper>
                </div>
            )}
        </section>
    );
};
